<template>
  <div>
    <div class="grey-subhead-bg text-uppercase">
      <h1>earn points</h1>
    </div>

    <div class="container">
      <br>
      <div class="row text-center">
        <div class="col-xs-12">
          <img src="../../assets/images/rewards/earn-points-echo.jpg" class="img-responsive center-block">
        </div>
      </div>
      <br><br>
      <div class="row">
        <div class="col-sm-4 col-sm-offset-2">
          <router-link
            :to="{name: 'EnterRebateItems', slug: this.$store.state.slug}"
            type="button"
            class="btn client-btn-primary btn-lg btn-block text-uppercase"
          >
            Enter Items
          </router-link>
          <br>
        </div>
        <div class="col-sm-4">
          <router-link
            :to="{name: 'TrainingCatalog', slug: this.$store.state.slug}"
            type="button"
            class="btn client-btn-primary btn-lg btn-block text-uppercase"
          >
            Training
          </router-link>
        </div>

      </div><br>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'EarnPoints',
  mounted () {
    this.getLoyaltyProgramBySlug(this.$store.state.slug)
  },
  methods: {
    ...mapActions('loyaltyProgram', [
      'getLoyaltyProgramBySlug'
    ])
  }
}
</script>
